import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";

export default function ServerManagement() {
  useEffect(() => {
    document.title = "Server Management Services To Handle Your Needs";
        sal();
      }, []);
  return (
    <>
     <Helmet>
        <title>Server Management Services To Handle Your Needs</title>
        <meta name="description" content="Our skilled team ensures optimal backup solutions for your server at regular intervals. Trust us to handle the complexities while you focus on your business." />
        <meta name="keywords" content="server managment,manage a server,manage servers,server manager,managed server hosting" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/server-management`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/server-management`} />
        <meta property="og:title" content="Server Management Services To Handle Your Needs" />
        <meta property="og:description" content="Our skilled team ensures optimal backup solutions for your server at regular intervals. Trust us to handle the complexities while you focus on your business." />
      </Helmet>
      <section className="banner-bg bg-dark ssl-banner">
        <div className="container">
            <div className="row align-items-center g-4">
              <div className="col-lg-6">
                  <div className="pb-40">
                    <span className="fs-18 fw-bold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Your Server is in Safe Hands.</span>
                    <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Smile! You’re at the Right Place for Server Management</h1>
                    <p className="text-white mb-8 max-text-60 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Just think that you are working late, and suddenly your website struggles a lot with lag…your heartbeat drops. With us, it's gone. With our server management, you stay happy all the time while everything runs just like clockwork.</p>
                    <Link to="/contact-us" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium btn-height rounded sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine" data-discover="true">
                      <span className="btn-arrow__text">Get Started
                        <span className="btn-arrow__icon">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </span>
                    </Link>
                  </div>
              </div>
              <div className="col-lg-6 col-xxl-6 ipad-mt">
                  <div className="cloud-hero__img sal-animate" data-sal="fade" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine"><img alt="image" className="img-fluid full-width-img" src="/images/server-management-banner.webp" /></div>
              </div>
            </div>
        </div>
      </section>
      <div className="simple-box-section pb-100 linux-hosting-points-section">
        <div className="pb-60">
            <div className="container">
              <div className="row g-4 align-items-center justify-content-xl-between">
                  <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>More Peace of Mind.</small>
                    <h2 className="mb-4">Web Hosting That Really Turns “What If” Into “Ohh!!! Glad I Did” </h2>
                  </div>
                  <div className="col-lg-6 col-xl-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="card">
                        <div className="card-body cloud-hosting-vid-card">
                                <div className="features-video position-relative z-1">
                                    <img src="/images/infi-common-video-yt-thumb.jpg" alt="image" className="img-fluid w-100"/>
                                    <Link to="https://youtu.be/x10KM9gI110?si=kVgGnbSAsh-zfKn7" target="_blank" className="btn gradient-bg w-15 h-15 d-grid place-content-center rounded-circle position-absolute top-50 start-50 translate-middle fs-24 text-white popup-init">
                                        <i className="fa-solid fa-play"></i>
                                    </Link>
                                </div>
                            </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
        <div className="container">
            <div className="row g-4">
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/cpanel-fixed.webp" /></div>
                        <h6 className="mb-4">cPanel? Fixed.</h6>
                        <p className="mb-0">Glitches? Our cPanel support keeps Amazon AWS servers (& all others) running smoothly.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/server-stress.webp" /></div>
                        <h6 className="mb-4">Server Stress?</h6>
                        <p className="mb-0">No more tech mess-just seamless, quick server management with full administrative access.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/support-247.webp" /></div>
                        <h6 className="mb-4">Support? 24/7.</h6>
                        <p className="mb-0">Our experts manage all your servers 24/7, so you can stress-freely enjoy your holidays.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/virtualization-care.webp" /></div>
                        <h6 className="mb-4">Virtualization Care??</h6>
                        <p className="mb-0"> With managed server hosting, our team manages OpenVZ, Xen, and KVM nodes, 24/7.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/ms-hyper-v-quick.webp" /></div>
                        <h6 className="mb-4">MS Hyper-V? Quick.</h6>
                        <p className="mb-0">Boost performance with virtualized Windows servers & advanced resource utilization.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/stack-got-you.webp" /></div>
                        <h6 className="mb-4">Stack? Got You.</h6>
                        <p className="mb-0">We handle all your dedicated servers with OpenStack infrastructure care-easy, reliable.</p>
                    </div>
                  </div>
              </div>
            </div>
        </div>
      </div>

      <div className="pb-60">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/infrastructure-under-budget.webp" alt="image" className="img-fluid" />
                    </div>
                    <div className="col-md-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                 Work? Strong Performance.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Infrastructure Under Budget
                            </h3>
                            <ul>
                                <li>Scalable IT setup with 24/7 professional support.</li>
                                <li>Advanced servers and modern tools manage complex tasks.</li>
                                <li>Experts always keep servers at blazing-fast performance.</li>
                                <li>Security monitoring. Stop unwanted attacks before they really hit.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-md-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Up? All The Time.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Your Website Never Sleeps
                            </h3>
                            <ul>
                                <li>We know downtime can harm your profit-every single minute counts.</li>
                                <li>That’s why we instantly deploy advanced servers and tools.</li>
                                <li>With our dedicated server management, your site grows all the time.</li>
                                <li>Go for us and get peace of mind with our 99.9% uptime.</li>
                            </ul>
                            <Link to="/contact-us" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Get Started Now
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/website-never-sleeps.webp" alt="image" className="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </div>

      <section>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>We Manage. You Move Faster.
                        </small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Managed Hosting Messes Up, Your Business Pays Off</h2>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">AWS? Managed.</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/aws-managed.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Our team manages all the tasks on Amazon AWS, giving you full control and management.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Apps? Scaled. </h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/apps-scaled.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Our professionals manage your Microsoft Azure apps and instances-smoothly, all day.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Cloud? Yes.</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/cloud-yes.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Don’t worry-our pros keep your Google Cloud servers running smoothly all the time.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0"> Downtime? No.</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">04</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/built-for-high-performance.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">But with the help of hosting and server management, your site keeps running.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <section className="simple-box-section pt-100 pb-100">
        <div className="container">
          <div className="row">
              <div className="col-12">
                  <div className="card rounded-3 cta-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      <div className="card-body px-6 pt-60 pb-60">
                          <div className="row justify-content-center">
                              <div className="col-md-11 col-lg-8 col-xl-8">
                                  <div className="text-center">
                                    <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">24/7 Expert Monitoring</span>
                                      <h4 className="mb-4">
                                          Server Management Made Easy
                                      </h4>
                                      <p className="mb-6">
                                        Hire Our Experts, Sleep Stress-Free 
                                      </p>
                                      <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2 btn-height">
                                          <span className="d-inline-block me-1 flex-shrink-0">
                                              <i className="las la-comments"></i>
                                          </span>
                                          <span className="btn-arrow__text">
                                              +91-7737300013
                                              <span className="btn-arrow__icon">
                                                  <i className="fa-solid fa-arrow-right"></i>
                                              </span>
                                          </span>
                                      </Link>
                                      <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded ms-sm-2 mt-sm-0 mt-4 open-live-chat btn-height">
                                          <span className="d-inline-block me-1 flex-shrink-0">
                                              <i className="las la-comments"></i>
                                          </span>
                                          <span className="btn-arrow__text">
                                              Talk to an Expert
                                              <span className="btn-arrow__icon">
                                                  <i className="fa-solid fa-arrow-right"></i>
                                              </span>
                                          </span>
                                      </Link>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </section>
    </>
  );
}

